export const CONSULT_TYPE = {
  SIMPLE_CONSULT: 2,
  VIDEO_CONSULT: 4
};
export const prescriptionTypeNames = {
  2: '图文咨询',
  4: '视频咨询'
};
